export class Photo {
  id: number;
  entfield_id: number;
  entdata_id: number;
  path: string;
  filename: string;

  fileBase64: string | ArrayBuffer;
}
